import React from 'react';
import { Link } from 'react-router-dom';
import { useWeb3 } from '../contexts/Web3Context';

function Header() {
  const { account, isConnected, connectWallet, disconnectWallet } = useWeb3();

  const formatAddress = (address) => {
    if (!address) return '';
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  return (
    <header className="site-header">
      <div className="container header-container">
        <div className="landing-logo-container">
          <Link to="/" className="landing-logo">
            <span className="gradient-text">PASSLY</span>
          </Link>
          <span className="landing-header-beta-tag">BETA</span>
        </div>
        
        <nav className="main-nav">
          {isConnected && (
            <>   
              <div className="wallet-address-container">
                <div className="wallet-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 14h.01"></path>
                    <path d="M18 14h.01"></path>
                    <path d="M20 9H4"></path>
                  </svg>
                </div>
                <span className="wallet-address">
                  {formatAddress(account)}
                </span>
              </div>
              
              <button
                onClick={disconnectWallet}
                className="btn-glass btn-glass-danger"
              >
                Disconnect
              </button>
            </>
          )}
          
          {!isConnected && (
            <button
              onClick={connectWallet}
              className="btn-glass btn-glass-primary"
            >
              <div className="btn-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 12l-4-4v3H3v2h15v3l4-4z"></path>
                </svg>
              </div>
              Connect Wallet
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;